<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Button from "@/components/c-button";
import moment from 'moment'
import { propertyService } from "../../../../services/reportservice/propertyservice.js";


/* eslint-disable no-console */
export default {
  page: {
    title: "Property Gropu Summary Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Select, 
  },
  data() {
    return {
      title: "Property Gropu Summary Report",
      data: [],
      project_name: 'ទាំងអស់',
      projects: {},

      dataStartDate: '',
      dataEndDate: '',
      dataProjectId: 0,
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadingData();
    
  },
  methods: {
    
     
    loadingData: function() {
      
      propertyService.getProperSummaryByGroup()
        .then(response => {
          this.data = response.data.property_group;
          this.projects = response.data.projects;
          this.project_name = response.data.project_name;
        });
    },
    submitSearch: function() {
      let data = '?project_id='+this.dataProjectId;
      propertyService.getProperSummaryByGroup(data)
        .then(response => {
          this.data = response.data.property_group;
          this.project_name = response.data.project_name;
          this.projects = response.data.projects;
      });
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    discountPrice(price, discount, dis_type) {
        let total = 0;
        if(dis_type==1){
          total = price * discount / 100;
        }else{
          total = discount
        }
        return total
    },
    formatCurrency(value) {
      if(value == 0 ){
        return 0;
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
    }
  },
  computed: {
    totalPrice() {
      return this.data.reduce(function (sum, item) {
        return sum + (item.total_interest + item.total_paid_loan)
      }, 0)
    },
    
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.property.group-summary')" />
      <div class="row seach-area">
        <div class="col-sm-2">
          <Select
            :id="'id'"
            :text="'label'"
            :editable="true"
            :list="{data: this.projects}"
            v-model="dataProjectId"
          /> 
        </div>
        <div class="col-sm-2">
          <Button v-bind:icon="'bx bx-search'"
            @click="submitSearch()" 
            v-bind:buttonType="'button'"
            v-bind:variant="'primary'"
            v-bind:title="$t('general.search')" 
          />
        </div>
      </div>
      <div id="print-area">
        <!-- <center> -->
          
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 092 685 009 | 098 685 009 Email: account@h-residence.net</p>
                </td>
                <td class="">
                    <p class="khb"><u>{{$t('report.property.group-summary')}}</u></p>
                    <!-- <p class=""><u>ប្រចាំខែ: {{this.dateFormat(date.start_date)}} - {{this.dateFormat(date.end_date)}}</u></p> -->
                    <p class="khb"><u>គម្រោង: {{this.project_name}}</u></p>
                </td>
              </tr>
              
            </table>
            <br/>
            <table class="content-general h8 project-sumary-table" width="100%">
              
                <tr class="thead">
                  <th>#</th>
                  <th>{{$t('report.property.group-col')}}</th>
                  <th>{{$t('report.property.total-property')}}</th>
                  <th>{{$t('report.property.sold')}}</th>
                  <th>{{$t('report.property.booked')}}</th>
                  <th>{{$t('report.property.aviable')}}</th>
                  <th>{{$t('report.property.price')}}</th>
                  <th>{{$t('report.property.sale-price')}}</th>
                  <th>{{$t('report.property.loan')}}</th>
                  <th>{{$t('report.property.paid-loan')}}</th>
                  <th>{{$t('report.property.paid-interest')}}</th>
                  <th>{{$t('report.property.total-balance')}}</th>
                </tr>
              
              <tbody>
                <tr v-for="(list, index) in data" :key="index" >
                  <td>{{index + 1}}</td>
                  <td>{{list.group_name}}</td>
                  <td>{{list.total_property}}</td>
                  <td>{{list.total_sold}}</td>
                  <td>{{list.total_booked}}</td>
                  <td>{{list.total_aviable}}</td>
                  <td>{{formatCurrency(list.total_price)}}</td>
                  <td>{{formatCurrency(list.total_sale_price)}}</td>
                  <td>{{formatCurrency(list.total_loan)}}</td>
                  <td>{{formatCurrency(list.total_paid_loan)}}</td>
                  <td>{{formatCurrency(list.total_interest)}}</td>
                  <td>{{formatCurrency(list.total_paid_loan + list.total_interest)}}</td>
                </tr>
              </tbody>
                <tr class="tfoot" v-if="data">
                  <td colspan="11" class="text-end pe-2">{{$t('report.total')}}</td>
                  <td class="text-center border-start border-dark ps-2">{{formatCurrency(totalPrice)}}</td>
                </tr>
            </table>
          
            <div class="row mt-3">
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>អគ្គនាយកក្រុមហ៊ុន</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>អគ្គនាយកក្រុមហ៊ុន</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកបច្ចេកទេស</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>ប្រធានគ្រប់គ្រងទូទៅ</p>
                </center>
              </div>
            </div>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>